import React, { useEffect } from 'react';
import {
  Square,
  Heading,
  Column,
  Row,
  Copy,
  Stack,
  Flex,
} from '@grubhubprod/gh-cookbook-react/dist';
import { useParams } from 'react-router-dom';
import Table from 'src/components/Table/Table';
import { useDepartmentEmployeesSearch } from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentName/EnterpriseDepartmentHooks/departmentHooks';
import { ISearchParams } from 'src/utilities/useSearchHooks';
import { Pagination } from 'src/components/Pagination/Pagination';
import { NoResultsMsg } from 'src/components/Table/NoResultsMsg';

export default function DepartmentEmployeeList(): JSX.Element {
  const { corpid: corpId, departmentId } =
    useParams<{ corpid: string; departmentId: string }>();

  const {
    doSearch,
    resultsList: employees,
    currentSearchPage,
    totalPages,
    totalResults,
    hasNoResultsWithoutQuery,
  } = useDepartmentEmployeesSearch(corpId, departmentId);

  useEffect(() => {
    doSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Square>
        <Stack y="sm">
          <Heading variant="h4">Employees in Department</Heading>
        </Stack>
        <Stack y="sm">
          <Table
            header={() => (
              <Row gutter={12}>
                <Column gutter={12} phone={6}>
                  <Copy variant="body" color="secondaryText">
                    Name
                  </Copy>
                </Column>
                <Column gutter={12} phone={6}>
                  <Copy variant="body" color="secondaryText">
                    Email
                  </Copy>
                </Column>
              </Row>
            )}
            body={() => (
              <>
                {employees.map(
                  ({ first_name, last_name, id, email }, index) => (
                    <Square
                      inset="sm"
                      key={id}
                      borderBottom={
                        index === employees.length - 1 ? 'none' : '1px solid'
                      }
                      borderTop={index !== 0 ? 'none' : '1px solid'}
                      borderColor="lightLine"
                    >
                      <Row data-testid="employee-info-row" gutter={12}>
                        <Column gutter={12} phone={6}>
                          {`${first_name} ${last_name}`}
                        </Column>
                        <Column gutter={12} phone={6}>
                          {email}
                        </Column>
                      </Row>
                    </Square>
                  )
                )}
                {hasNoResultsWithoutQuery && (
                  <NoResultsMsg message="There are currently no employees. Why don't you add some?" />
                )}
              </>
            )}
            showFooter={false}
          />
        </Stack>
        {totalPages > 1 && (
          <Flex justifyContent="center">
            <Pagination
              boundaryLinks
              page={currentSearchPage}
              collectionSize={totalResults}
              pageChange={(page) => {
                const searchParams: ISearchParams = { page };
                doSearch(searchParams);
              }}
            />
          </Flex>
        )}
      </Square>
    </>
  );
}
